import AuthorizedPages from "../../authorizedPages";
import FavortiteLawsuitCard from "../../components/Cards/FavoriteLawsuitCard";
import FreeExpiredGuard from "../../components/FreeExpiredGuard";
import Menu from "../../components/Menu";
import NavbarDashboard from "../../components/NavbarDashboard";
import "./styles.css";

function Favorites() {
  return (
    <FreeExpiredGuard>
      <NavbarDashboard />

      <body className="home">
        <Menu />

        <div className="height"></div>

        <div className="container">
          <div className="container-favorites">
            <AuthorizedPages page={"favorite"}>
              <FavortiteLawsuitCard />
            </AuthorizedPages>
          </div>
        </div>
      </body>
    </FreeExpiredGuard>
  );
}

export default Favorites;
